<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">
			
			<div class="modal__head">
				<div class="modal__head__title">Utility Mapping</div>
				<div class="modal__head__subtitle">Utility detection &amp; mapping surveys</div>
				<div class="modal__pres__controls">

					<div class="col md-4 modal__pres__control">
						<button @click="activeBtn = 'btn1'" :class="{active: activeBtn === 'btn1' }" class="outline">Info</button>
					</div>
								
					<div class="col md-4 modal__pres__control">
						<button @click="updatePresImg('service5.sample1.png'), activeBtn = 'btn2'" :class="{active: activeBtn === 'btn2' }" class="outline">Sample 1</button>
					</div>

					<div class="col md-4 modal__pres__control">
						<button @click="updatePresImg('service5.sample2.png'), activeBtn = 'btn3'" :class="{active: activeBtn === 'btn3' }" class="outline">Sample 2</button>
					</div>

					<div class="clearfix"></div>

				</div>
				<div class="clearfix"></div>
			</div>
			
			<div v-if="activeBtn === 'btn2' || activeBtn === 'btn3'">
				<div class v-if="activeBtn === 'btn2'">
						<!-- <div class="sample">
						<div class="sample__title">Measured Building Surveys</div>
						<div class="sample__subtitle">Floor plans, elevations, sections. Large or small projects considered.</div>
						</div> -->
					</div>
					<div class v-if="activeBtn === 'btn3'">
						<!-- <div class="sample">
						<div class="sample__title">3D laser scanning</div>
						<div class="sample__subtitle">Laser scanning and drones to provide immersive datasets</div>
						</div> -->
					</div>
				<div class="modal__content modal__content--pres">
					<div class="col md-12 sample-image">
						<div v-if="activeBtn === 'btn2' || activeBtn === 'btn3'">
							<img :src="require('@/assets/images/' + modalPresImg)" alt="">
						<button class="primary pres-close sample-image-close" @click="closeModaler">Close</button>
						</div>
					</div>
					<div class="clearfix"></div>
				</div>
			</div>
		
			<div class v-if="activeBtn === 'btn1'">
					<div class="modal__content">
						<ul>	
							<div class="col md-6">
								<li>Used by engineers, architects, designers, planners, numerous technical consultants and throughout construction.</li>
								<li>Desktop Utility Reports</li>
								<li>Utility Detection &amp; mapping</li>
								<li>On Site Markup</li>
							</div>
							<div class="col md-6">
								<li>PAS128 spec. available</li>
								<li>GPR Surveys</li>
								<li>CCTV and Drainage Surveys</li>
								<li>Your quote request will be passed on to our Utility Mapping partner who will provide a quote directly.</li>
							</div>
						</ul>
						<div class="clearfix"></div>
						<button class="primary pres-close" @click="closeModaler">Close</button>
					</div>
				</div>
			</div>
	</appBaseModal>
</template>

<script>
    import BaseModal from './BaseModal';
	export default {
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'serviceOption5Modal',
				modalPresImg: 'pres-op--std.png',
				activeBtn:'btn1'
			}
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			}
		},
		methods: {
			updatePresImg: function (message) {
				// Vue.set(this.modalPresImg, 'test')
				// alert(this.modalPresImg)
				this.modalPresImg = message
			},
			updateServicesList: function (message) {
				// Vue.set(this.modalPresImg, 'test')
				// alert(this.modalPresImg)
				this.modalServicesList = message
			},
			closeModaler(){
				return this.$store.commit('closeModal', '');
			}		
		}

		
	}
	
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/serviceOption5Modal.vue